import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import './AddButton.scss';

const AddButton = ({ children, disabled, ...restProps }) => {
  const contentClass = !disabled ? 'add-button-content' : 'add-button-content-disabled';
  return (
    <Button
      className="add-button"
      disabled={disabled}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}>
      <div className={contentClass}>
        <div className="add-button-icon">
          <PlusOutlined />
        </div>
        <span className="add-button-label">{children}</span>
      </div>
    </Button>
  );
};

AddButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool
};

AddButton.defaultProps = {
  disabled: false
};
export default AddButton;
